import styled from 'styled-components';

export const ImageModal = styled.img`
  align-self: center;
  justify-self: center;
  max-width: 100%;
  padding: 16px 0px 0px 0px;
`;
